/* eslint-disable react/jsx-props-no-spreading */

import {
    ToolbarButton,
    ColumnsPanelTrigger,
    FilterPanelTrigger,
} from '@mui/x-data-grid-pro'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'

import Divider from '@mui/material/Divider'
import FilterIcon from 'app/shared-components/FilterIcon'

import useStyles from '../SkyNetDataGridToolbar.style'
import ExportToolbarMenu from '../../ExportToolbarMenu'
import {
    ToolbarSharedProps,
} from '../SkyNetDataGridToolbar'
import useClearSorting from '../hooks/useClearSorting'
import ClearSortingIcon from '../../ClearSortingIcon'
import CreateButton from '../CreateButton'
import useAllowedActionsMap, {
    ActionsMap,
} from '../hooks/useAllowedActionsMap'

const actionsMap: ActionsMap = {
    Create: <CreateButton />,
    Print: <div>Print Btn</div>,
    BulkCreate: <div>Bulk Create Btn</div>,
    BulkEdit: <div>Bulk Edit Btn</div>,
}

const DefaultViewToolbarActions = ({
    toolbarControls,
    showFilterButton,
    toolbarActions,
}: Readonly<ToolbarSharedProps>) => {
    const {
        classes,
    } = useStyles()

    const handleClearSorting = useClearSorting()

    const actions = useAllowedActionsMap({
        actionsMap,
        toolbarActions,
    })

    return (
        <>
            {actions.Create && (
                <>
                    {actions.Create}
                    <Divider
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        sx={{
                            mx: 1,
                        }}
                    />
                </>
            )}

            {toolbarControls?.map((control, index) => {
                // eslint-disable-next-line react/no-array-index-key
                return <div key={`toolbar-control-${index}`}>{control}</div>
            })}
            {showFilterButton && (
                <Tooltip title="Filters">
                    <FilterPanelTrigger
                        render={(props, state) => {
                            return (
                                <ToolbarButton
                                    {...props}
                                    color="default"
                                    data-testid="filter-btn"
                                >
                                    <Badge
                                        badgeContent={state.filterCount}
                                        color="primary"
                                        variant="dot"
                                    >
                                        <FilterIcon
                                            className={classes.filter}
                                            newStyling
                                        />
                                    </Badge>
                                </ToolbarButton>
                            )
                        }}
                    />
                </Tooltip>
            )}
            <ExportToolbarMenu />
            <Tooltip title="Clear Sorting">
                <ToolbarButton
                    onClick={handleClearSorting}
                    data-testid="clear-sorting-btn"
                >
                    <ClearSortingIcon />
                </ToolbarButton>
            </Tooltip>

            <Tooltip
                title="Columns"
                data-testid="columns-menu"
            >
                <ColumnsPanelTrigger render={<ToolbarButton />}>
                    <ViewColumnIcon fontSize="small" />
                </ColumnsPanelTrigger>
            </Tooltip>
        </>
    )
}

export default DefaultViewToolbarActions
